
const reportsData = {
	title: "Reports",
	description: [
		"Download and read a range of documents providing detailed information on the work we do, the work of our partners and matters relevant to our sector as a whole.",
	],
	reports: [
		{
			title: "Tutuwa Reports",
			item: [
				{
					title: "Tutuwa Decennial Report",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tutuwa_Decennial_Report_2025.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | Tutuwa Decennial Report | download link click"
					}
				},
				{
					title: "Impact Investing – A Handbook for Foundations",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Impact_Investing-A_Handbook_for_Foundations.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | impact investing - a handbook for foundations | download link click"
					}
				},
				{
					title: "Tutuwa Impact Report 2022",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tutuwa_Impact_Report-2022.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | tutuwa impact report 2022 | download link click"
					}
				},
				{
					title: "Tutuwa Strategy Plan 2021–2025",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/2021-2025_Tutuwa_Strategy_Plan_Final_interactive_short_version.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | tutuwa strategy plan 2021-2025 | download link click"
					}
				},
				{
					title: "Tutuwa Strategy Plan 2017–2020",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tutuwa-Community-Strategy-2017-2020.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | tutuwa strategy plan 2017-2020 | download link click",
					}
				},
				{
					title: "Standard Bank Tutuwa Community Foundation Brochure",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tututwa-Brochure.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | standard bank tutuwa community foundation brochure | download link click",
					}
				},
				{
					title: "Scholars Graduation Class of 2020",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tutuwa-Foundation_Booklet_Final.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | scholars graduation class of 2020 | download link click",
					}
				},
				{
					title: "Tutuwa Impact Report 2019",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tutuwa-Impact-Report-LR-Spreads.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | tutuwa impact report 2019 | download link click",
					}
				},
				{
					title: "Tutuwa Review Report 2016–2018",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Tutuwa-Review-Report-2016-2018.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | tutuwa review report 2016-2018 | download link click",
					}
				},
				{
					title: "Intellidex SIBs in SA Report 2021",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Intellidex-SIBs-in-SA-Report-2021.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | intellidex sibs in sa report 2021 | download link click",
					}
				},
				{
					title: "CDE NEETs Report 2021 ",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/CDE-NEETs-Report-2021.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | cde neets report 2021 | download link click",
					}
				},
				{
					title: "Scholars Graduation Class of 2021",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Graduation-Ceremony-2021-GMS-19685-Tutuwa-Booklet-DIGITAL.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | scholars graduation class of 2021 | download link click",
					}
				},
				{
					title: "Intellidex Bonds4Jobs Social Impact Bond 2021",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Intellidex-the-B4J-SIB-report.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | intellidex bonds4jobs social impact bond 2021 | download link click",
					}
				},
				{
					title: "Intellidex Impact Bond Innovation Fund 2021",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Intellidex-the-IBIF-SIB-report.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "tutuwa reports | intellidex impact bond innovation fund 2021 | download link click",
					}
				},
			]
		},
		{
			title: "Partner Reports",
			item: [
				{
					title: "Child Gauge 2020",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/ChildGauge_2020_screen_final.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "partner reports | child gauge 2020 | download link click",
					}
				},
				{
					title: "Child Gauge 2019",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/South-African-Child-Gauge-2019.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "partner reports | child gauge 2019 | download link click",
					}
				},
				{
					title: "Child Gauge 2018",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/South-African-Child-Gauge-2018.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "partner reports | child gauge 2018 | download link click",
					}
				},
				{
					title: "Child Gauge 2017",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/South-African-Child-Gauge-2017.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "partner reports | child gauge 2017 | download link click",
					}
				},
			]
		},
		{
			title: "Sector reports",
			item: [
				{
					title: "Intellidex Understanding Empowerment Endowments Report 2018 ",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "/assets/downloads/Understanding-Empowerment-Endowments.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "sector reports | intellidex understanding empowerment endowments report 2018 | download link click",
					}
				},
				{
					title: "Fact Sheet on “NEETs” 2021 ",
					link: {
						modifier: "download",
						target: "_blank",
						text: "Download",
						url: "https://www.dhet.gov.za/Planning%20Monitoring%20and%20Evaluation%20Coordination/Fact%20Sheet%20on%20NEET%20-%202021.pdf",
						dataIntent: "transactional",
						dataScope: "link component",
						dataId: "link_content",
						dataText: "sector reports | fact sheet on neets 2021 | download link click",
					}
				},
			]
		},
	]
}

export { reportsData };
